import { render, staticRenderFns } from "./VideoDetailsPage.vue?vue&type=template&id=dcea2ca0&scoped=true&"
import script from "./VideoDetailsPage.vue?vue&type=script&lang=js&"
export * from "./VideoDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./VideoDetailsPage.vue?vue&type=style&index=0&id=dcea2ca0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcea2ca0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VBtn,VCard,VCardActions,VDialog,VImg,VSpacer})
